var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "step_age" } }, [
    _c("div", { staticClass: "container" }, [
      _c("h2", [
        _vm._v(
          "How much do " +
            _vm._s(_vm.$root.is_mini_or_baby ? "they" : "you") +
            " weigh?"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.lazy",
              value: _vm.$root.weight,
              expression: "$root.weight",
              modifiers: { lazy: true },
            },
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: "put your lbs weight here",
            type: "number",
            min: "1",
            step: ".1",
            required: "",
          },
          domProps: { value: _vm.$root.weight },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.$root, "weight", $event.target.value)
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }